/*
Controller: PackageSuggestions

Operations:
  getPackageSuggestions
*/
var Api = require('../config')

var PackageSuggestions = (function () {
  /*
  Operation: getPackageSuggestions
  Get package and price suggestions
  Parameters:
    submissionId: Id of the submission
  Responses:
    HTTP 200: Suggestion created
  */
  function getPackageSuggestionsPackageSuggestions (submissionId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/submissions/{submissionId}/packageSuggestions'
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['getPackageSuggestions'] = getPackageSuggestionsPackageSuggestions
  return ret
})()

module.exports = PackageSuggestions
